import api from 'services/api';

/**
 * 부서관리 화면 전용 엔드유저 챗.
 * 테넌트는 JWT만 사용 — body 에 기관코드를 넣지 않는다.
 */
export async function postDeptAiChat({ message, confirm = false, previewId = '', screenId = 'ADM_DEPT' }) {
  const res = await api.post('/ai/dept/chat', {
    screenId,
    message: message || '',
    confirm: !!confirm,
    previewId: previewId || undefined,
  });
  return res?.data || {};
}
